import { render, staticRenderFns } from "./RepresentativeRestaurantReport.vue?vue&type=template&id=3cb70562"
import script from "./RepresentativeRestaurantReport.vue?vue&type=script&lang=js"
export * from "./RepresentativeRestaurantReport.vue?vue&type=script&lang=js"
import style0 from "./RepresentativeRestaurantReport.vue?vue&type=style&index=0&id=3cb70562&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports